const env = 'prod';
export const environment = {
  production: true,
  baseUrl: 'https://verto.co',
  teamTailorKey: '5jfGtv8uVBL55Hu6BREGXtnjq3AwRtOwAmGwWsw_',
  teamTailorBaseAPIUrl: 'https://api.teamtailor.com',
  cardAPI: 'https://api-cards-beta.vertofx.com/activate',
  slug: env,
  currencyAPI:
    'https://api-currency-beta.vertofx.com/p/currencies/exchange-rate',
  currencyAPIlist: 'https://api-currency-beta.vertofx.com/p/currencies/list',
  postHog: {
    enabled: true,
    apiKey: 'phc_cEqpHLS7dYO42OPFzAxSf4N0ijOy1F0DUKqVj48OZ4r',
    apiHost: 'https://eu.i.posthog.com',
    personProfiles: 'identified_only' as const
  },
};
